import { TeachingLocation, UpdateLocationProps } from 'types/location'
import { authorizedRequest } from '..'

export const updateLocation = async (
  locationData: UpdateLocationProps
): Promise<TeachingLocation> => {
  try {
    const { id, ...updateData } = locationData
    const response = await authorizedRequest({
      endpoint: `location/${id}`,
      method: 'PATCH',
      body: updateData,
    })
    const { location } = (await response.json()) as {
      success: true
      location: TeachingLocation
    }
    return location
  } catch (e: any) {
    throw e
  }
}
